import MobileServiceClient from "@mocobaas/client-js/build/MobileServiceClient";
import {
  GetListParams,
  GetListResult,
} from "react-admin";
import gql from "graphql-tag";
import { ProviderBase } from "./ProviderBase";
import { buildArgs } from "./utils";
import moment from "moment";
export class CoinTransferProviderClass extends ProviderBase<any> {
  client: MobileServiceClient;

  constructor(client: MobileServiceClient) {
    super();
    this.client = client;
  }

  async getList(
    _resource: string,
    params: GetListParams
  ): Promise<GetListResult> {
    const where: Record<string, any> = {};
    const filterArray: any[] = [];

    let dateGTE = moment().startOf("month").startOf("day").toISOString();
    let dateLTE = moment().endOf("month").endOf("day").toISOString();

    filterArray.push({
      remark: {
        _ilike: `%Transfer Balance to%`,
      },
    });

    if (params.filter.q) {
      filterArray.push({
        user_id_data: {
          name: {
            _ilike: `%${params.filter.q}%`,
          },
        },
      });
    }
    if (params.filter.dateGte || params.filter.dateLte) {
      dateLTE = moment(params.filter.dateLte).toISOString();
      dateGTE = moment(params.filter.dateGte).toISOString();

      filterArray.push({
        created_at: {
          _gte: dateGTE,
        },
      });
      filterArray.push({
        created_at: {
          _lte: dateLTE,
        },
      });
    }

    if (params.filter.status === "FAILED") {
      filterArray.push({
        status: {
          _ilike: params.filter.status,
        },
      });
    }
    if (params.filter.name) {
      filterArray.push({
        wallet_id_data: {
          user_id_data: {
            name: { _ilike: `%${params.filter.name}%` },
          },
        },
      });
    }

    if (params.filter.phone) {
      filterArray.push({
        wallet_id_data: {
          user_id_data: {
            phone: { _ilike: `%${params.filter.phone}%` },
          },
        },
      });
    }

    if (params.filter.target) {
      filterArray.push({
        remark: {
          _ilike: `%to ${params.filter.target}%`,
        },
      });
    }

    if (params.filter.orderId) {
      filterArray.push({
        transfer_balance_id: {
          _ilike: `%${params.filter.orderId}%`,
        },
      });
    }

    if (filterArray.length > 0) {
      if (params.filter.q) {
        where._or = filterArray;
      } else {
        where._and = filterArray;
      }
    }

    const { page, perPage } = params.pagination;
    let { field, order } = params.sort;
    const args = buildArgs({
      order: order || "DESC",
      size: perPage,
      pageNumber: page,
      sort: field || "created_at",
    });
    const queryResult = await this.client.gql.query({
      query: gql`
      query WalletReloadList($where:WalletLedgersWhereInput) {
        allWalletLedgersList(
          where: $where, ${args}
          ){
            data {
              id
              created_at
              balance
              remark
              credit
              debit
              transfer_balance_id
              wallet_id_data{
                user_id_data{
                  name
                  phone
                }
              }
            }
          count
        }
      }
      `,
      variables: {
        where,
      },
    });
    if (params.filter.status === "FAILED") {
      return { data: [], total: 0 };
    }
    return {
      data: queryResult?.allWalletLedgersList?.data || [],
      total: queryResult?.allWalletLedgersList?.count || 0,
    };
  }
}
